import React, { useEffect, useState } from 'react';

import PropsPassedMessage from './components/PropsPassedMessage/PropsPassedMessage';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Loader from '@appComponents/Loader/Loader';
import Confirmation from './components/Confirmation/Confirmation';
import MessageBox from './components/MessageBox/MessageBox';
import Error from './components/Error/Error';

import MessageService from '@services/Message.service';
import { getTitle } from './features/helpers/functions';
import { IMessageApp, TApiReceivedTokenData, TPropsPassedMessage } from './IMessageApp';
import { catchError } from '@features/utils/functions';
import { FooterInformationsBlock } from "@bundles/otherApps/FooterApp/components/FooterInformationsblock";

import * as errorStyle from './components/Error/ErrorStyle.module.scss';
import * as style from './MessageAppStyle.module.scss'

const MessageApp = (props: IMessageApp) => {
  const resource = props.match.params.token;

  const [dataFromApi, setDataFromApi] = useState<undefined | TApiReceivedTokenData>(undefined);
  const [error, setError] = useState<number | string | undefined>(undefined);
  const dataFromProps: null | TPropsPassedMessage = props.messages[resource];

  const customFooterTexts = dataFromProps && dataFromProps.footer;
  const title: string | null =
    (dataFromProps && dataFromProps.header) || getTitle(dataFromApi! && dataFromApi!.event_type) || 'Confirmation Unavailable';

  useEffect(() => {
    if (!dataFromProps) {
      MessageService.getConfirmationDetails(resource)
        .then((res) => {
          setDataFromApi(res.data);
        }).catch((err) => {
          if (err.response.status === 404) return setError(404);
          catchError(err, `/error/${err.response.status}`);
        });
    }
  }, []);

  const renderContent = (): JSX.Element | null => {
    if (error === 404) {
      return (
        <Error withRedirect={true}>
          This request is expired, invalid or it has been already decided.
        </Error>
      );
    }

    if (error === 'confirm_error') {
      return (
        <Error withRedirect={false}>
          <p>
            Sorry, something went wrong. please contact support and use this token
            as a reference:
            <span className={errorStyle.errorMessage}>{resource}</span>
          </p>
        </Error>
      );
    }

    if (dataFromApi) {
      return <Confirmation setError={setError} data={dataFromApi}/>;
    }

    if (dataFromProps) {
      return <PropsPassedMessage box={dataFromProps.box}/>;
    }

    return null;
  };

  return (
    <div className={style.messagePage}>
      <div className={style.messageContainer}>
        {!error && !dataFromProps && !dataFromApi ? (
          <div className={style.messageLoader}>
            <Loader fullWidth={true} />
          </div>
        ) : (
          <>
            {props.logoutButton && (
              <a href="/users/sign_out" className={style.logout}>
                Log out
              </a>
            )}
            {title && <Header text={title} />}
            <MessageBox>{renderContent()}</MessageBox>
            <div className={style.messageFooterContainer}>
              <FooterInformationsBlock />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default (props: IMessageApp) => <MessageApp {...props} />;
